module.exports = __webpack_public_path__ + "img/search.ebdedc11.svg";